import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/download-qr.png'


const _withScopeId = n => (_pushScopeId("data-v-0e495eb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("微信登录 ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "qr",
  alt: "安装二维码"
}, null, -1))

import { MobileOutlined, MailOutlined, WechatOutlined } from '@ant-design/icons-vue'
import { reactive, ref, UnwrapRef } from 'vue'
import { ValidateErrorEntity } from 'ant-design-vue/es/form/interface'
import { message } from 'ant-design-vue'
import { ApiSession } from '@/api/http/session'
import notification from 'ant-design-vue/es/notification'
import { ILoginForm } from '@/api/typings'
import { StoreSessionActions } from '@/lib/store/modules/session/actions'
import router from '@/lib/router'
import { ISession, IWxFan } from '@/interface'
import { StoreCashierActions } from '@/lib/store/modules/cashier/actions'
import store from '@/lib/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeKey = ref('wx')
/**
 * 微信业务
 */
const wxAuth = reactive({
  isAuthing: !!router.currentRoute.value.query.code,
  fan: {} as IWxFan
})
const onWxAuth = () => {
  wxAuth.isAuthing = true
  location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wx0608d7294112c165&redirect_uri=${encodeURI('https://mywsy.cn/auth')}&response_type=code&scope=snsapi_login&state=${process.env.NODE_ENV === 'production' ? 'web' : 'webdev'}#wechat_redirec`
}

if (wxAuth.isAuthing) {
  store.dispatch(StoreSessionActions.doWxAuth, router.currentRoute.value.query.code as string).then((rs: unknown) => {
    if ('headimgurl' in (rs as { [key: string]: unknown })) {
      wxAuth.fan = rs as IWxFan
    } else {
      console.log(rs)
      jump(rs as ISession)
    }
  }).catch(() => {
    wxAuth.isAuthing = false
  })
}

/**
 * 表单业务
 */
// 表单数据
const formStat: UnwrapRef<ILoginForm> = reactive({
  phone_number: '',
  code: '',
  wx_open_id: ''
})

// 验证规则
const rules = {
  phone_number: [
    {
      required: true,
      message: '请输入手机号',
      trigger: 'blur'
    },
    {
      pattern: /^1[3456789]\d{9}$/,
      message: '手机号格式错误',
      trigger: 'blur'
    }
  ],
  code: [
    {
      required: true,
      message: '请输入验证码',
      trigger: 'blur'
    },
    {
      pattern: /^[0-9]{4}$/,
      message: '验证码错误',
      trigger: 'blur'
    }
  ]
}

// 验证码相关
const smsState = reactive({
  smsSending: false,
  countdown: 60,
  logging: false
})

// 发送验证码
const sendSms = (e: Event): void => {
  e.preventDefault()
  formRef.value.validateFields('phone_number').then(() => {
    smsState.smsSending = true
    const interval = setInterval(() => {
      if (smsState.countdown-- <= 0) {
        smsState.countdown = 60
        smsState.smsSending = false
        clearInterval(interval)
      }
    }, 1000)
    const msgClose = message.loading('验证码发送中..', 0)
    ApiSession.smsCaptcha(formStat.phone_number).then(() => {
      setTimeout(msgClose, 1500)
      notification.success({
        message: '提示',
        description: '验证码获取成功',
        duration: 3
      })
    }).catch((err) => {
      if (/404/.test(err)) {
        notification.info({
          message: '尚未注册',
          description: '请手机扫码安装“管店宝”App，完成门店注册。',
          duration: 3
        })
        activeKey.value = 'reg'
      }
      setTimeout(msgClose, 1)
      clearInterval(interval)
      smsState.countdown = 60
      smsState.smsSending = false
    })
  }).catch(() => {
    // do nothing
  })
}

// 表单ID
const formRef = ref()

// 登录
const onLogin = (e: Event): void => {
  e.preventDefault()
  smsState.logging = true
  formRef.value.validate().then(() => {
    formStat.wx_open_id = wxAuth.fan.openid
    console.log('validate ok! ', formStat)
    store.dispatch(StoreSessionActions.doLogin, formStat).then((rs: ISession) => jump(rs)).catch(err => {
      console.log(err)
      formStat.phone_number = ''
      formStat.code = ''
      notification.error({
        message: err.message
      })
      smsState.logging = false
      smsState.smsSending = false
    })
  }).catch((err: ValidateErrorEntity<ILoginForm>): void => {
    console.log(err)
    smsState.logging = false
  })
}

const jump = (rs: ISession) => {
  console.log('>>>>', rs.id_cards.length === 1)
  // 判断如何跳转
  if (rs.id_cards.length === 1) {
    store.dispatch(StoreCashierActions.onJoin, rs.id_cards[0])
    router.push({ name: 'workspace' })
  } else {
    console.log('>>>> pickIds')
    router.push({ name: 'pickIds' })
  }
  setTimeout(() => {
    notification.success({
      message: '欢迎',
      description: '欢迎回来'
    })
  }, 1000)
  console.log(rs)
}


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    activeKey: activeKey.value,
    "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((activeKey).value = $event))
  }, {
    default: _withCtx(() => [
      (!_unref(wxAuth).fan.openid)
        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: "wx",
            tab: "微信登录",
            style: {"min-height":"323px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_result, { status: "success" }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(WechatOutlined))
                ]),
                extra: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    shape: "round",
                    size: "large",
                    loading: _unref(wxAuth).isAuthing,
                    onClick: onWxAuth
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_tab_pane, {
        key: "login",
        tab: '手机号' + (_unref(wxAuth).fan.openid === undefined ? '登录' : '绑定'),
        style: {"min-height":"323px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            class: "user-layout-login main",
            ref_key: "formRef",
            ref: formRef,
            model: _unref(formStat),
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { name: "phone_number" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    size: "large",
                    type: "number",
                    placeholder: "手机号",
                    value: _unref(formStat).phone_number,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formStat).phone_number) = $event)),
                    name: "phone_number",
                    autocomplete: "off"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(MobileOutlined), { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    class: "gutter-row",
                    span: 16
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "code" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            size: "large",
                            type: "number",
                            placeholder: "验证码",
                            value: _unref(formStat).code,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formStat).code) = $event)),
                            name: "code",
                            autocomplete: "off"
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_unref(MailOutlined), { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    class: "gutter-row",
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "getCaptcha",
                        tabindex: "-1",
                        disabled: _unref(smsState).smsSending,
                        textContent: _toDisplayString(!_unref(smsState).smsSending && '获取验证码' || (_unref(smsState).countdown+' s')),
                        onClick: _withModifiers(sendSms, ["stop","prevent"])
                      }, null, 8, ["disabled", "textContent", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { style: {"margin-top":"24px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "large",
                    type: "primary",
                    htmlType: "submit",
                    class: "login-button",
                    loading: _unref(smsState).logging,
                    disabled: _unref(smsState).loading,
                    onClick: onLogin
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(wxAuth).fan.openid === undefined ? '登录' : '绑定'), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["tab"]),
      _createVNode(_component_a_tab_pane, {
        key: "reg",
        tab: "App注册",
        style: {"min-height":"323px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_result, {
            status: "success",
            "sub-title": "手机扫码安装"
          }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["activeKey"]))
}
}

})